import React from "react";

export const UserNameContext = React.createContext<string | undefined | null>(undefined);
